const simpleSliderStyle = ({ palette }) => ({
  root: {
    // overflow: 'hidden',
    // padding: '30px 0',
    // margin: '-20px 0 -30px',
    width: '100%',
  },
  track: {
    background: palette.primary.main,
    height: '5px',
    borderRadius: '10px',
  },
  rail: {
    background: palette.divider,
    height: '5px',
    borderRadius: '10px',
    opacity: 1,
  },
  thumb: {
    marginTop: '-4px',
  },
})

export default simpleSliderStyle
